import { render, staticRenderFns } from "./ShowEntityName.vue?vue&type=template&id=72211f0c"
import script from "./ShowEntityName.vue?vue&type=script&lang=js"
export * from "./ShowEntityName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports